import { useServicesState } from "../store/servicesStateStore";
import { getRoomForSpace, useRoomNotesStore } from "../store/roomNotesStore";
import { RoomNoteSaveResult } from "../services/coreApi/RoomNoteSaveResult";
import { RoomNoteSaveErrorEnum } from "../enums/RoomNoteSaveErrorEnum";

export const ROOM_NOTE_MAX_LENGTH = 2000; // After trimming. CoreAPI itself has no limit.

/**
 * Saves a space's note as its CoreAPI room's comment and, on success, stores the saved note so the label updates.
 * The room id comes from the apartment's own room list: CoreAPI doesn't check that a room belongs to the project.
 */
export const saveRoomNote = async (globalId: string, notes: string | null): Promise<RoomNoteSaveResult> => {
    if ((notes?.trim().length ?? 0) > ROOM_NOTE_MAX_LENGTH) return { ok: false, error: RoomNoteSaveErrorEnum.Validation };

    const room = getRoomForSpace(useRoomNotesStore.getState().rooms, globalId);
    if (!room) return { ok: false, error: RoomNoteSaveErrorEnum.NotFound };

    const dataProvider = useServicesState.getState().dataProvider;
    if (!dataProvider) return { ok: false, error: RoomNoteSaveErrorEnum.Failed };

    const result = await dataProvider.updateRoomNote(room.id, notes);
    if (result.ok) {
        useRoomNotesStore.getState().setNote(globalId, result.notes);
    }
    return result;
};
